export function preventDoubleClickSelection(e: React.MouseEvent) {
    if (e.nativeEvent.detail > 1) {
        e.preventDefault();
    }
}
